import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UniButtonsModule, UniHeadingModule, UniIconsModule, UniRadioModule, UniFormFieldModule } from "@universal-ui";
import { ModalModule } from "ngx-bootstrap/modal";

import { DateModule } from "../../shared/Modules/date.module";
import { FormComponentsModule } from "../../shared/Modules/formComponents.module";
import { SharedModule } from "../../shared/Modules/shared.module";
import { TableModule } from "../../shared/Modules/table.module";
import { ValidatorsModule } from "../../shared/Modules/validators.module";

import { SelectProfileDropdownComponent } from "./Components/select-profile-dropdown/select-profile-dropdown.component";
import { SelectProfileModalComponent } from "./Components/select-profile-modal/select-profile-modal.component";
import { DashboardPerfilesComponent } from "./Dashboard/dashboard.component";
import { FormularioPerfilesComponent } from "./Formulario/formulario.component";
import { PerfilesRoutingModule } from "./perfiles-routing.module";

@NgModule({
  declarations: [
    DashboardPerfilesComponent,
    FormularioPerfilesComponent,
    SelectProfileModalComponent,
    SelectProfileDropdownComponent,
  ],
  imports: [
    PerfilesRoutingModule,
    SharedModule,
    DateModule,
    ValidatorsModule,
    FormComponentsModule,
    ModalModule.forRoot(),
    TableModule,
    UniIconsModule,
    UniRadioModule,
    UniButtonsModule,
    UniHeadingModule,
    FormsModule,
    UniFormFieldModule,
  ],
  exports: [SelectProfileDropdownComponent, UniRadioModule],
})
export class PerfilesModule {}
